import { __rest, __assign } from 'tslib';
import React from 'react';
import cn from 'classnames';
import { SIZE_TO_CLASSNAME_MAP } from '../../consts.js';
import { Footer } from './Component.js';

var styles = {"sticky":"side-panel__sticky_1yvr1","size-500":"side-panel__size-500_1yvr1"};
require('./desktop.css')

var FooterDesktop = function (_a) {
    var _b;
    var _c = _a.size, size = _c === void 0 ? 500 : _c, className = _a.className, sticky = _a.sticky, restProps = __rest(_a, ["size", "className", "sticky"]);
    return (React.createElement(Footer, __assign({ className: cn(className, size && styles[SIZE_TO_CLASSNAME_MAP[size]], (_b = {},
            _b[styles.sticky] = sticky,
            _b)), sticky: sticky }, restProps)));
};

export { FooterDesktop };
